import React, { useEffect, useState } from "react";

import AntDTable from "../AntDTable/AntDTable";

import { Card } from "antd";
import { getTherapeutics } from "../Helpers/API/CheckUpApi/CheckUpApi";
import { formatDate } from "../Helpers/Utilities/Common";
import { Col, Row } from "react-bootstrap"

function TherapeuticsHistory(props) {
  const [showLoader, setShowLoader] = useState(false);
  const [data, setData] = useState([]);

  // Function get therapeutic API
  async function fetchTherapeutics() {
    setShowLoader(true);
    const res = await getTherapeutics({
      patient_id: props.patientId,
    });

    if (res.data) {
      const rows = Array.isArray(res.data) ? res.data : [];
      var _parsed = rows.map((data) => {
        return {
          ...data,
          added_on: formatDate(data.added_on),
        };
      });
      setData(_parsed);
    } else if (res.error) {
      setData([]);
    }
    setShowLoader(false);
  }

  useEffect(() => {
    fetchTherapeutics();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Card className="card-with-table">
      <div className="card-table">
        <Row className="align-items-center pb-4 px-2">
          <Col xs={"auto"} className="p-0 align-items-center">
            <h5 className="font-bold">THERAPEUTICS HISTORY</h5>
          </Col>
        </Row>
        <AntDTable
          tableHeaders={[
            "GENERIC",
            "BRAND",
            "QUANTITY",
            "PREPARATION",
            "FORM",
            "DOSAGE",
            "DURATION",
            "ROUTE",
            "FREQUENCY",
            "TIMING",
            "NOTES",
            "PRESCRIBED ON",
          ]}
          headerSelector={[
            "generic",
            "brand",
            "quantity",
            "preparation",
            "form",
            "dosage",
            "duration",
            "route",
            "frequency",
            "timing",
            "note",
            "added_on",
          ]}
          tableData={data}
          loading={showLoader}
          scroll={{ x: true }}
          isClickable={false}
        />
      </div>
    </Card>
  );
}

export default TherapeuticsHistory;
